import apiBase from 'src/api/api-base';
import { endpoints } from 'src/config/endpoints';
import Certification from 'src/models/certification';

export const getAllCertifications = async (): Promise<Certification[]> =>
  new Promise((resolve, reject) => {
    apiBase.get(endpoints.certifications.getAll).then((response) => {
      resolve(response.data as Certification[]);
    });
  });
export const getCertification = async (id: number | string): Promise<Certification> =>
  new Promise((resolve, reject) => {
    apiBase.get(endpoints.certifications.get(id)).then((response) => {
      resolve(response.data as Certification);
    });
  });
export const createCertification = async (certification: any): Promise<Certification> =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    const hasFile = certification.pdf instanceof File;

    if (hasFile) {
      formData.append('pdf', certification.pdf);
    }

    Object.keys(certification).forEach((key) => {
      if (key === 'pdf') return;
      const value = certification[key];
      if (key === 'yards') {
        formData.append('yards', JSON.stringify(value));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value.toString());
      }
    });

    const payload = hasFile ? formData : certification;
    apiBase
      .post(endpoints.certifications.create, payload)
      .then((response) => {
        resolve(response.data as Certification);
      })
      .catch(reject);
  });
export const updateCertification = async (certification: any): Promise<Certification> =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    const hasFile = certification.pdf instanceof File;

    if (hasFile) {
      formData.append('pdf', certification.pdf);
      formData.append('_method', 'PUT');
    }

    Object.keys(certification).forEach((key) => {
      if (key === 'pdf') return;
      const value = certification[key];
      if (key === 'yards') {
        formData.append('yards', JSON.stringify(value));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value.toString());
      }
    });

    const payload = hasFile ? formData : certification;
    const apiMethod = hasFile ? apiBase.post : apiBase.put;

    apiMethod(endpoints.certifications.update(certification.id), payload)
      .then((response) => {
        resolve(response.data as Certification);
      })
      .catch(reject);
  });
export const deleteCertification = async (id: number | string): Promise<Certification> =>
  new Promise((resolve, reject) => {
    apiBase.delete(endpoints.certifications.delete(id)).then((response) => {
      resolve(response.data as Certification);
    });
  });
